module.exports = __webpack_public_path__ + "static/media/map-store.66d2ee1b.png";